import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { TEditTeaserSelectedContentType } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import React, { useMemo } from 'react';
import { ITeaserContentType } from 'types';
import { useTranslation } from 'react-i18next';

interface IClientTypeSelect {
	selectedContentType: TEditTeaserSelectedContentType;
	setContentType: (value: TEditTeaserSelectedContentType) => void;
}

const ContentTypeSelect: React.FC<IClientTypeSelect> = ({ selectedContentType, setContentType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectContentType') }], [t]);

	const getAvailableToChangeContentTypes = () => {
		const contentTypesMap: { [groupName: string]: ITeaserContentType[] } = {
			advertisingContentType: [
				{ id: 'AdvertisingVideo', name: 'contentTypeAdvertisingVideo' },
				{ id: 'AdvertisingImage', name: 'contentTypeAdvertisingImage' },
			],
			assistantContentType: [
				{ id: 'AssistantVideo', name: 'contentTypeAssistantVideo' },
				{ id: 'AssistantImage', name: 'contentTypeAssistantImage' },
			],
			gameLaunchContentType: [
				{ id: 'GameLaunchVideo', name: 'contentTypeGameLaunchVideo' },
				{ id: 'GameLaunchImage', name: 'contentTypeGameLaunchImage' },
			],
		};

		const contentTypeGroups = Object.values(contentTypesMap);

		return (
			contentTypeGroups.find((el) =>
				selectedContentType ? el.some((el) => el.id === selectedContentType) : null,
			) || []
		);
	};

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return getAvailableToChangeContentTypes().map((el) => ({ id: el.id, name: tForm(el.name) }));
	}, [getAvailableToChangeContentTypes, tForm]);

	return (
		<FormSelect
			testId="ContentTypeSelect"
			name="selectedContentType"
			label="contentTypeLabel"
			options={mappedOptions}
			onChange={setContentType}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ContentTypeSelect);
